function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMusicRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mtqdec39da"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 117112",
    style: {
      fill: "#d7262e"
    },
    d: "M0 0h40.969v40.98H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137211"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137193"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137192",
    style: {
      clipPath: "url(#mtqdec39da)"
    },
    transform: "translate(7.848 7.51)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121126",
    d: "M17.066 25.61a1.707 1.707 0 1 1-1.708-1.71 1.708 1.708 0 0 1 1.708 1.707m5.9-5.188 7.234-7.168a10.06 10.06 0 0 1-.429 13.107A8.611 8.611 0 0 1 27.473 28a.288.288 0 0 0-.17.227 12.033 12.033 0 0 1-11.29 12.734q-.486.03-.972.019A15.019 15.019 0 0 1 4.5 36.479c-5.591-5.586-6.029-14.24-.983-19.293a12.245 12.245 0 0 1 9.221-3.511.438.438 0 0 0 .232-.188 8.572 8.572 0 0 1 1.639-2.294 10.073 10.073 0 0 1 13.184-.362l-7.232 7.159zm-11.1 12.946L7.595 29.1l-2.407 2.412 4.269 4.269zm8.617-7.757a5.122 5.122 0 1 0-5.123 5.123 5.123 5.123 0 0 0 5.123-5.123M40.085.884a3.018 3.018 0 0 0-4.267 0l-3.386 3.384v1.974l-4.64 4.593A11.35 11.35 0 0 1 29.07 11.9a11.58 11.58 0 0 1 1.13 1.366l4.768-4.728H36.7l3.384-3.384a3.019 3.019 0 0 0 0-4.266",
    style: {
      fill: "#d7262e"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusicRed);
export default __webpack_public_path__ + "static/media/icon_music_red.69ea3ba0f196aaf34723d9c9f76341e2.svg";
export { ForwardRef as ReactComponent };